import { useEffect } from 'react';
import { IPost, IProduct } from '@monofront/types';
import { useMediaQuery } from '@monofront/business/hooks';
import { useProductPageContext } from '@context/ProductPageContext';
import ProductAside from './ProductAside';
import ProductBreadcrumb from './ProductBreadcrumb';
import ProductDetails from './ProductDetails';
import ProductFooter from './ProductFooter';
import ProductHero from './ProductHero';

interface IProductProps {
  product: IProduct;
  tips?: IPost[];
}

const Product: React.FC<IProductProps> = ({ product, tips }) => {
  const { breadcrumb, title } = product;
  const isMobile = useMediaQuery(800);
  const { setSku } = useProductPageContext();

  useEffect(() => {
    setSku(product.sku);
  }, []);

  return (
    <div className="tw-lf-layout-container tw-pt-4 desktop:tw-pt-6">
      <ProductBreadcrumb title={title} breadcrumb={breadcrumb} />

      <div className="double-column-section desktop:tw-flex desktop:tw-gap-12">
        <ProductAside product={product} />
        {!isMobile && (
          <div
            className={`
            tw-mt-5 desktop:tw-mt-7
            desktop:tw-min-w-[385px] min-[801px]:tw-w-[calc(50vw-3em)] min-[960px]:tw-w-auto
          `}
          >
            <ProductHero
              UNSAFE_className="tw-relative desktop:tw-sticky
            desktop:tw-top-[30px]"
              product={product}
            />
          </div>
        )}
      </div>

      <ProductDetails product={product} tips={tips} />

      <ProductFooter product={product} />
    </div>
  );
};

export default Product;
